import type { NexusHandler } from "../nexus/function/function.types.ts";
import type { AccessibilityRaw } from "./index.ts";

export const focus = ((element: HTMLElement | string): void => {
  const el = typeof element === "string" ? document.querySelector<HTMLElement>(element) : element;
  if (!el) return;
  const hasTabindex = el.hasAttribute("tabindex");
  if (!hasTabindex) el.setAttribute("tabindex", "-1");
  el.focus({ preventScroll: true });
  if (!hasTabindex) setTimeout(() => el.removeAttribute("tabindex"), 100);
}) satisfies NexusHandler<AccessibilityRaw["focus"]>;
